/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  hashtag modal reducers
 */

import { payloadReducer } from '@zcode/reducers'
import type { HashtagModal } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { handleAction } from 'redux-actions'
import { SET_CITY_STATE, SET_HASHTAG_TYPE, SET_RENT_REPORT } from '../constants/hashtagModal'
import type { ActionTypes } from '../types'

export const hashtagReducer = combineReducers<HashtagModal, ActionTypes>({
  cityState: handleAction<HashtagModal['cityState'], ActionTypes, typeof SET_CITY_STATE>(
    SET_CITY_STATE,
    payloadReducer,
    null
  ),
  modalType: handleAction<HashtagModal['modalType'], ActionTypes, typeof SET_HASHTAG_TYPE>(
    SET_HASHTAG_TYPE,
    payloadReducer,
    null
  ),
  rentReport: handleAction<HashtagModal['rentReport'], ActionTypes, typeof SET_RENT_REPORT>(
    SET_RENT_REPORT,
    payloadReducer,
    null
  ),
})
